import { render, staticRenderFns } from "./full-excursion-card.vue?vue&type=template&id=00640c13&"
import script from "./full-excursion-card.vue?vue&type=script&lang=ts&"
export * from "./full-excursion-card.vue?vue&type=script&lang=ts&"
import style0 from "./full-excursion-card.vue?vue&type=style&index=0&id=00640c13&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports